$(document).ready(function () {
    $('.fixed-sidebar, .site-sidebar').addClass('loaded');
});